// extracted by mini-css-extract-plugin
module.exports = {"root":"employeeuserlayout_root_1_Lhl","user":"employeeuserlayout_user_2GptB","main":"employeeuserlayout_main_CG7IL"};